export default __webpack_public_path__ + "static/media/file.cda06b4c.svg";